<div
  class="flex flex-col gap-2 md:flex-row items-center justify-between mb-[2.5rem] md:mb-6"
>
  <h2 class="self-start">{{ 'profile.title' | transloco }}</h2>
  <button class="cta self-end" (click)="disconnect()">
    {{"profile.disconnect" | transloco}}<icon
      [name]="'logout'"
      [size]="'1.125rem'"
    />
  </button>
</div>

<div class="flex flex-col gap-[1rem] md:gap-[1.5rem]">
  <div class="flex flex-col md:flex-row md:gap-[1.5rem]">
    <div
      class="md:flex-[1_1_51.5rem] flex flex-col gap-[1.5rem] md:gap-[1.8rem] md:pb-2 p-6 bg-white rounded-t-2xl md:rounded-2xl"
    >
      <div class="flex gap-[1rem]">
        <icon [name]="'growth'" [size]="'2.25rem'"></icon>
        <h4>{{ 'profile.myDashboard.title' | transloco }}</h4>
      </div>
      @if(loadingDashboard()) {
      <div class="my-[6.25rem]"><loader /></div>
      } @else {
      <div class="flex flex-col gap-[1.5rem] desktop-hidden">
        <div class="flex items-center gap-[1.5rem]">
          @if(userProfile?.photoUrl) {
          <img
            class="max-w-[5rem] max-h-[5rem] rounded-full"
            [src]="userProfile.photoUrl"
            alt="User Profile"
          />
          } @else {
          <img
            class="max-w-[5rem] max-h-[5rem] rounded-full"
            src="assets/images/user/user-contact-card.png"
            alt="User Profile Default"
          />
          }
          <h4>{{ userProfile?.firstName }} {{ userProfile?.lastName }}</h4>
        </div>
        <div class="flex flex-col gap-2">
          <p>
            {{ 'profile.myDashboard.sector' | transloco }} :
            <span class="font-bold">{{ userProfile?.job }}</span>
          </p>
          <p>
            {{ 'profile.myDashboard.division' | transloco }} :
            <span class="font-bold">{{ userProfile?.division }}</span>
          </p>
          <p>
            {{ 'profile.myDashboard.delegation' | transloco }} :
            <span class="font-bold">{{ userProfile?.delegation }}</span>
          </p>
        </div>
      </div>
      <div class="flex gap-[1.5rem] items-start mobile-hidden">
        @if(userProfile?.photoUrl) {
        <img
          class="max-w-[5rem] max-h-[5rem] rounded-full"
          [src]="userProfile.photoUrl"
          alt="User Profile"
        />
        } @else {
        <img
          class="max-w-[5rem] max-h-[5rem] rounded-full"
          src="assets/images/user/user-contact-card.png"
          alt="User Profile Default"
        />
        }
        <div class="flex flex-col gap-[1rem]">
          <h3>{{ userProfile?.firstName }} {{ userProfile?.lastName }}</h3>
          <div class="flex flex-col gap-2">
            <p>
              {{ 'profile.myDashboard.sector' | transloco }} :
              <span class="font-bold">{{ userProfile?.job }}</span>
            </p>
            <p>
              {{ 'profile.myDashboard.division' | transloco }} :
              <span class="font-bold">{{ userProfile?.division }}</span>
            </p>
            <p>
              {{ 'profile.myDashboard.delegation' | transloco }} :
              <span class="font-bold">{{ userProfile?.delegation }}</span>
            </p>
          </div>
        </div>
      </div>
      }
    </div>

    <div
      class="flex flex-col w-full gap-[1.5rem] p-6 bg-vinciLavender md:rounded-2xl rounded-b-2xl md:max-w-[25rem]"
    >
      <div class="flex flex-col gap-[1.5rem] h-full">
        <div class="flex gap-4 items-center pb-[1.5rem]">
          <icon [name]="'user'" [size]="'2.25rem'" class="flex-shrink-0"></icon>
          <h4>{{ 'profile.hrContact.title' | transloco }}</h4>
        </div>
        <p class="text-[0.875rem] !font-light flex-1">
          {{ 'profile.hrContact.redirectToHrContactPage' | transloco }}
        </p>
        <a
          routerLink="/user-profile/hr-contact"
          class="bg-white text-black hover:bg-vinciGrey-50 transition-colors duration-300 py-2 px-3 flex gap-2 w-fit font-bold text-base rounded-lg cursor-pointer whitespace-nowrap items-center"
        >
          {{ 'profile.hrContact.hrContactCtaText' | transloco }}
          <icon [name]="'arrow-right'" [size]="'0.75rem'" class="my-auto"></icon>
        </a>
      </div>
    </div>
  </div>

  @if(loadingFavoriteContacts()) {
  <div
    class="flex flex-col gap-[1rem] p-[2.5rem] md:py-[2rem] bg-white rounded-2xl"
  >
    <div class="flex justify-between items-center">
      <div class="flex gap-[1rem]">
        <icon [name]="'messages'" [size]="'2.25rem'"></icon>
        <h4>{{ 'profile.favoriteContacts.title' | transloco }}</h4>
      </div>
    </div>
    <div class="my-[6.25rem]"><loader /></div>
  </div>
  } @else {
  <div
    class="flex flex-col gap-[1rem] p-[2.5rem] md:py-[2rem] bg-white rounded-2xl"
  >
    <div class="flex justify-between items-center">
      <div class="flex gap-[1rem]">
        <icon [name]="'messages'" [size]="'2.25rem'"></icon>
        <h4>{{ 'profile.favoriteContacts.title' | transloco }}</h4>
      </div>
      @if(!isInEditMode()){
      <div class="mobile-hidden">
        <button
          class="cta text-vinciBlue-600"
          (click)="editFavoriteContacts()"
          [disabled]="userProfile?.contacts.length == 0"
        >
          {{ 'profile.favoriteContacts.updateMyContacts' | transloco }}
          <icon [name]="'pen'" [size]="'1.25rem'"></icon>
        </button>
      </div>
      @if (showFavoriteContactsForMobile()) {
      <div class="desktop-hidden">
        <button
          class="cta text-vinciBlue-600"
          (click)="editFavoriteContacts()"
          [disabled]="userProfile?.contacts.length == 0"
        >
          {{ 'profile.favoriteContacts.updateMyContacts' | transloco }}
          <icon [name]="'pen'" [size]="'1.25rem'"></icon>
        </button>
      </div>
      } } @else {
      <div class="flex flex-col md:flex-row gap-4">
        <app-button
          [text]="'profile.favoriteContacts.cancelEdit' | transloco"
          [variant]="'tertiary'"
          [icon]="'cancel'"
          (buttonClick)="closeEditFavoriteContacts()"
        ></app-button>
        <app-button
          [text]="'profile.favoriteContacts.confirmEdit' | transloco"
          [variant]="'secondary'"
          [icon]="'confirm'"
          (buttonClick)="saveFavoriteContacts()"
        ></app-button>
      </div>
      }
    </div>
    <div class="desktop-hidden">
      <button
        class="cta text-vinciBlue-400"
        [class.pb-[1rem]]="showFavoriteContactsForMobile()"
        (click)="setShowFavoriteContactsForMobile(!showFavoriteContactsForMobile())"
      >
        @if(showFavoriteContactsForMobile()) { {{
        'profile.favoriteContacts.hideTheFavoriteContacts' | transloco }}
        <icon [name]="'nav-arrow-up'" [size]="'1rem'"></icon>
        } @else { {{ 'profile.favoriteContacts.findYourFavoriteContacts' |
        transloco }}
        <icon [name]="'nav-arrow-down'" [size]="'1rem'"></icon>
        }
      </button>

      <div
        class="hidden"
        [class.!grid]="showFavoriteContactsForMobile()"
        [class.grid-cols-1]="showFavoriteContactsForMobile()"
        [class.md:grid-cols-3]="showFavoriteContactsForMobile()"
        [class.gap-[1.5rem]]="showFavoriteContactsForMobile()"
      >
        @for(contact of userProfile?.contacts; track $index){
        <app-contact-card
          [spId]="contact.spId"
          [name]="contact.firstName + ' ' + contact.lastName"
          [job]="contact.job"
          [photoUrl]="contact.photoUrl"
          [mail]="contact.mail"
          [phoneNumber]="contact.phoneNumber"
          [languages]="contact.languages"
          [location]="contact.location"
          [bookingLink]="contact.bookingCalendarLink"
          [isInEditMode]="isInEditMode()"
          (isDeletedTicked)="onDeletedTicked($event)"
        ></app-contact-card>
        }
      </div>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-3 gap-[1.5rem] mobile-hidden">
      @for(contact of userProfile?.contacts; track $index){
      <app-contact-card
        [spId]="contact.spId"
        [name]="contact.firstName + ' ' + contact.lastName"
        [job]="contact.job"
        [photoUrl]="contact.photoUrl"
        [mail]="contact.mail"
        [phoneNumber]="contact.phoneNumber"
        [languages]="contact.languages"
        [bookingLink]="contact.bookingCalendarLink"
        [location]="contact.location"
        [isInEditMode]="isInEditMode()"
        (isDeletedTicked)="onDeletedTicked($event)"
      ></app-contact-card>
      }
    </div>
  </div>
  }

  <div class="bento mb-[2.5rem]">
    <app-tile
      [title]="'profile.mobilityQuestionnaire.title' | transloco"
      [icon]="'thunder'"
      [text]="'<p>' + ('profile.mobilityQuestionnaire.text' | transloco) + '</p>'"
      [ctaText]="'profile.mobilityQuestionnaire.ctaText' | transloco"
      [ctaLink]="'/user-profile/portal-questionnaire'"
      [isRedirectionExternal]="false"
      [size]="'small'"
    ></app-tile>
    <app-tile
      [title]="'profile.myDocuments.title' | transloco"
      [icon]="'folder'"
      [text]="'<p>' + ('profile.myDocuments.text' | transloco) + '</p>'"
      [ctaText]="'profile.myDocuments.ctaText' | transloco"
      [ctaLink]="'/user-profile/documents'"
      [isRedirectionExternal]="false"
      [size]="'medium'"
      [image]="'assets/images/tiles/document.png'"
      [showImageOnMobile]="false"
    ></app-tile>
    <app-tile
      [title]="'profile.yourFeedbackMatter.title' | transloco"
      [text]="'<p>' + ('profile.yourFeedbackMatter.text' | transloco) + '</p>'"
      [variant]="'secondary'"
      [ctaText]="'profile.yourFeedbackMatter.ctaText' | transloco"
      [ctaLink]="'/user-profile/feedback'"
      [isRedirectionExternal]="false"
      [size]="'medium'"
    ></app-tile>
    <app-tile
      [title]="'profile.faq.title' | transloco"
      [variant]="'tertiary'"
      [text]="'<p>' + ('profile.faq.text' | transloco) + '</p>'"
      [ctaText]="'profile.faq.ctaText' | transloco"
      [ctaLink]="'/user-profile/faq'"
      [isRedirectionExternal]="false"
      [size]="'small'"
    ></app-tile>
  </div>
</div>
<div class="p-6 md:p-10 flex flex-col gap-4 bg-white rounded-xl mb-[5rem]">
  <div class="flex flex-col md:flex-row justify-between items-center">
    <h4 class="flex items-center self-start gap-2">
      <icon [name]="'thumb-up'" [size]="'1.375rem'"></icon>{{
      'profile.myFavorites.title' | transloco }}
    </h4>
    @if (!isInEditFavoritesMode()) {
    <button
      class="cta text-vinciBlue-600 self-end"
      (click)="toggleEditFavoriteMode()"
      [disabled]="searchFavorites().length == 0 && videoFavorites().length == 0 && tilesFavorites().length == 0"
    >
      {{ 'profile.myFavorites.editMyFavorites' | transloco }}
      <icon [name]="'pen'" [size]="'1rem'" />
    </button>
    } @else {
    <div class="flex flex-col md:flex-row items-center gap-2 self-end">
      <app-button
        [text]="'profile.myFavorites.cancelEditText' | transloco"
        [variant]="'tertiary'"
        [icon]="'cancel'"
        (buttonClick)="toggleEditFavoriteMode()"
        class="self-end"
      ></app-button>
      <app-button
        [text]="'profile.myFavorites.confirmEditText' | transloco"
        [variant]="'secondary'"
        [icon]="'save-file'"
        [iconSize]="'1.25rem'"
        (buttonClick)="confirmEditFavoritesMode()"
      ></app-button>
    </div>
    }
  </div>

  <div class="flex flex-col md:flex-row gap-[1.625rem]">
    <div class="rounded-xl p-6 bg-vinciLavender flex flex-col gap-6 flex-1">
      <p class="flex gap-2 items-center !font-bold">
        <icon [name]="'glass'" [size]="'1rem'" /> {{
        'profile.myFavorites.savedSearchText' | transloco}}
      </p>
      @if(loadingFavoriteSearches()) {
      <loader class="m-auto" />
      } @else {@if(searchFavorites().length !== 0){
      <div class="flex flex-col gap-2 max-h-[21rem] overflow-y-auto">
        @for (favoriteSearch of searchFavorites(); track $index) {
        <app-card-favorite-search
          [favoriteFilter]="favoriteSearch"
          [isInEditMode]="isInEditFavoritesMode()"
          (isSelected)="updateSearchesToRemoveFromFavorite($event)"
          (applySearch)="onFavoriteSearchClick($event)"
        ></app-card-favorite-search>
        }
      </div>
      } @else {
      <p class="m-auto">
        {{ 'profile.myFavorites.noSavedSearchText' | transloco }}
      </p>
      } }
    </div>

    <div class="rounded-xl p-6 bg-vinciLavender flex flex-col gap-6 flex-1">
      <p class="flex gap-2 items-center !font-bold">
        <icon [name]="'briefcase'" [size]="'1rem'" /> {{
        'profile.myFavorites.favoriteToolsText' | transloco}}
      </p>
      @if (loadingFavoriteTiles()) {
      <loader class="m-auto" />
      } @else {@if(tilesFavorites().length !== 0){
      <div class="flex flex-col gap-2 max-h-[21rem] overflow-y-auto">
        @for (tile of tilesFavorites(); track $index) {
        <app-card-favorite
          [objectId]="tile.id"
          [title]="tile.title"
          [link]="tile.link"
          [textDisclaimer]="tile.textDisclaimer"
          [isRedirectionExternal]="tile.isExternalLink"
          [isInEditMode]="isInEditFavoritesMode()"
          (isSelected)="updateTilesToRemoveFromFavorites($event)"
        ></app-card-favorite>
        }
      </div>
      } @else {
      <p class="m-auto">
        {{ 'profile.myFavorites.noFavoriteToolText' | transloco }}
      </p>
      }}
    </div>
    <div class="rounded-xl p-6 bg-vinciLavender flex flex-col gap-6 flex-1">
      <p class="flex gap-2 items-center !font-bold">
        <icon [name]="'portrait'" [size]="'1rem'" /> {{
        'profile.myFavorites.jobPortraitsText' | transloco }}
      </p>
      @if (loadingFavoriteTiles()) {
      <loader class="m-auto" />
      } @else {@if(videoFavorites().length !== 0){
      <div class="flex flex-col gap-2 max-h-[21rem] overflow-y-auto">
        @for (video of videoFavorites(); track $index) {
        <app-card-favorite
          [objectId]="video.id"
          [title]="video.title"
          [link]="video.link"
          [textDisclaimer]="video.textDisclaimer"
          [isInEditMode]="isInEditFavoritesMode()"
          (isSelected)="updateTilesToRemoveFromFavorites($event)"
        ></app-card-favorite>
        }
      </div>
      } @else {
      <p class="m-auto">
        {{ 'profile.myFavorites.noFavoriteVideoText' | transloco }}
      </p>
      }}
    </div>
  </div>
</div>
